import { render, staticRenderFns } from "./PublicProjectFavoriteModels.vue?vue&type=template&id=0bda2c24&scoped=true&"
import script from "./PublicProjectFavoriteModels.vue?vue&type=script&lang=js&"
export * from "./PublicProjectFavoriteModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda2c24",
  null
  
)

export default component.exports